module.exports = __webpack_public_path__ + "img/huanbao.94ea11b3.jpg";